import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/image/logo.png'


const _hoisted_1 = { class: "nav-big" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_4 = { class: "right" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "beian-bottom",
  "data-v-45e510d6": ""
}, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://beian.miit.gov.cn/",
    target: "_blank",
    "data-v-45e510d6": ""
  }, "备案序号：沪ICP备2021002968号-4")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "beian-bottom",
  "data-v-45e510d6": ""
}, "互联网药品信息服务资格证书编号：（沪）-非经营性-2024-0067", -1)

import { ref, reactive, toRef, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

let router = useRouter();
let route = useRoute()

let navIndex: any = ref(0);
let navArr: any[] = reactive([
  {
    title: '首页',
    to: '/'
  },
  {
    title: '关于我们',
    to: '/about'
  },
  {
    title: '品牌故事',
    to: '/brand'
  },
  {
    title: '产品介绍',
    to: '/product'
  },
  {
    title: '招商合作',
    to: '/attract'
  },
  {
    title: '联系我们',
    to: '/contact'
  }
])

// 刷新页面导航保持点击
// let currentPath = window.location.href.split('/#')[1]
// let finInd = navArr.findIndex(item => {
//   return item.to == currentPath
// })
// console.log(finInd)
// navIndex.value = finInd

// 切换tab导航
function navigate(index: number, item: any) {
  navIndex.value = index
  router.push({
    path: item.to
  })
}

// 监听路由切换导航
watch(() => route.path, newRoute => {

  console.log(newRoute, 'iii')
  let finInd = navArr.findIndex(item => {
    return item.to == newRoute
  })

  if (finInd != -1) {
    navIndex.value = finInd
  }

})



return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navArr), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              onClick: ($event: any) => (navigate(index, item)),
              class: _normalizeClass([index == _unref(navIndex) ? 'active' : ''])
            }, _toDisplayString(item.title), 11, _hoisted_5))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_router_view),
    _hoisted_6,
    _hoisted_7
  ], 64))
}
}

})